import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import {
    PREVIEW_MODE_PARAM,
    PREVIEW_REFRESH_PATHNAME,
    detectStorefrontPreview,
} from '../../utils/preview-mode-utils';
import { useSSRPreviewMode } from './useSSRPreviewMode';

/**
 * This hook is used to add the preview mode parameter to the URL if it is inside an iframe the does not belong to the same domain.
 */
export const useAddPreviewParamIfNeeded = (): void => {
    const location = useLocation();
    const isSSRPreviewMode = useSSRPreviewMode();
    const hasAttemptedRedirect = useRef<boolean>(false);
    useEffect(() => {
        if (
            !hasAttemptedRedirect.current &&
            !isSSRPreviewMode &&
            detectStorefrontPreview() &&
            location.pathname !== PREVIEW_REFRESH_PATHNAME
        ) {
            const newUrl = new URL(window.location.href);
            newUrl.searchParams.set(PREVIEW_MODE_PARAM, Date.now().toString());
            window.location.replace(newUrl.toString());
            hasAttemptedRedirect.current = true;
        }
    }, [isSSRPreviewMode, location.pathname]);
};
